import { createQuery } from '@/utils/tanstack-query/createQuery';

import { getStdObjects } from './utils/getStdObjects';

export const useStdObjects = createQuery({
  key: ['stdObjects'],
  queryFn: getStdObjects,
});
